"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=pointers.js.map